// controllers/video_editor_modal_controller.js
import { TurboMountController } from "turbo-mount";
export default class extends TurboMountController {}